import { ConnectionStatus, Network } from '@capacitor/network';
import { useIonToast } from '@ionic/react';
import { t } from '@lingui/macro';
import { useCallback, useEffect } from 'react';

const NetworkStatus: React.FC = () => {
    const [presentToast, dismissToast] = useIonToast();
    const checkStatus = useCallback(
        async (status: ConnectionStatus, offlineOnly: boolean = false) => {
            const online =
                status.connected &&
                (status.connectionType === 'wifi' ||
                    status.connectionType === 'cellular');
            const offline =
                !status.connected ||
                status.connectionType === 'none' ||
                status.connectionType === 'unknown';

            await dismissToast();

            if (online && !offlineOnly) {
                presentToast({
                    message: t`You are online`,
                    duration: 5000,
                    color: 'success',
                    position: 'bottom',
                    buttons: [
                        {
                            text: t`Dismiss`,
                            role: 'cancel',
                        },
                    ],
                });
            } else if (offline) {
                presentToast({
                    message: t`You are offline`,
                    duration: 5000,
                    color: 'warning',
                    position: 'bottom',
                    buttons: [
                        {
                            text: t`Dismiss`,
                            role: 'cancel',
                        },
                    ],
                });
            }
        },
        [dismissToast, presentToast]
    );

    useEffect(() => {
        Network.addListener('networkStatusChange', checkStatus);

        const checkCurrentNetworkStatus = async () => {
            const status = await Network.getStatus();
            checkStatus(status, true);
        };

        checkCurrentNetworkStatus();

        return () => {
            Network.removeAllListeners();
        };
    }, [checkStatus]);

    return <></>;
};

export default NetworkStatus;
